import React, { useEffect, useRef, useState } from 'react';
import Button from 'shared/components/Button/Button';

interface Props {
  buttonClickHandler: () => void;
}

const TechnicalError = ({ buttonClickHandler }: Props) => {
  const [loading, setLoading] = useState(false);

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const onClickHandler = () => {
    setLoading(true);
    buttonClickHandler();

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setLoading(false);
    }, 10000);
  };

  useEffect(() => () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  return (
    <div className="d-flex flex-column" style={{ backgroundColor: '#ededed', padding: '20px' }}>
      <p>
        We’re very sorry, there has been a technical problem with our payment service. We don’t want to delay you from obtaining your new breakdown product.
        So please call us on <span style={{ color: '#f95108' }}>0330 159 1466</span> and a member of the team can help you.
      </p>
      <div className="d-flex justify-content-end">
        <Button
          buttonStyles={{ width: '150px' }}
          loading={loading}
          buttonText="Try again"
          chevronWhite
          onClickHandler={onClickHandler}
        />
      </div>
    </div>
  );
};

export default TechnicalError;
